import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Checkbox, FeatureOptionContainer } from './FeatureOption.style';

interface FeatureOptionProps {
  segmentationClass: any;
  hotkey: string;
  isActive: boolean;
  isLabeled: boolean;
  setActive: () => void;
}

const FeatureOption = ({
  segmentationClass,
  hotkey,
  isActive,
  isLabeled,
  setActive,
}: FeatureOptionProps) => {
  const label = segmentationClass;

  const handleFeatureOptionOnClick = () => {
    setActive();
  };

  useHotkeys(hotkey, event => {
    event?.preventDefault();
    setActive();
  });

  return (
    <FeatureOptionContainer
      isLabeled={isLabeled}
      isActive={isActive}
      onClick={handleFeatureOptionOnClick}
    >
      <Checkbox checked={isLabeled} readOnly />({hotkey}) {label}
    </FeatureOptionContainer>
  );
};

export default FeatureOption;
